import React from "react";
import ReadMore from "shared/components/readMore";
import ApiProductProfileView from "shared/types/ApiProductProfileView";
import { ProductInfo } from "./types";
import ViewProfileOverview from "../overview";
import { getSchemaFieldsForDisplayProfile } from "../../utils";

export default function ViewVendorProducts(props: { products?: Array<ApiProductProfileView> }) {
  return (
    <React.Fragment>
      {props.products?.map((o: ApiProductProfileView) => (
        <RenderProduct product={o} />
      ))}
    </React.Fragment>
  );
}

function RenderProduct(props: { product?: ApiProductProfileView }) {
  const productPlatformInfo = React.useMemo(() => {
    return props.product?.platformFieldsProfile as ProductInfo;
  }, [props.product?.platformFieldsProfile]);

  const updatedProductSchemaList = React.useMemo(() => {
    if (props.product?.profile.length) {
      return getSchemaFieldsForDisplayProfile(props.product.profile);
    }
    return [];
  }, [props.product?.profile]);

  return (
    <div className="productCard">
      <div className="productCard_header">
        <div className="productCard--content">
          <div className="productCard--content_title">{productPlatformInfo.productName}</div>
          <div className="productCard--content_desc">
            <ReadMore height={96} paragraphLines={6} isHTMLFormatted content={productPlatformInfo.productDescription} />
          </div>
        </div>
        <div className="productCard--img">
          <img src={productPlatformInfo.productImageAsset} alt="" />
        </div>
      </div>
      <div className="productCard_body">
        <div className="productCard--overview">
          <ViewProfileOverview profile={updatedProductSchemaList} />
        </div>
      </div>
    </div>
  );
}
